const RU = {
  'staff.title': 'Сотрудники',
  'staff.subtitle': 'Учётные записи, роли по объектам и средства входа',

  'staff.tab.list': 'Список',
  'staff.tab.profile': 'Мой профиль',

  'staff.filter.site': 'Объект',
  'staff.filter.site.any': 'Все доступные',
  'staff.filter.status': 'Статус',
  'staff.filter.status.any': 'Любой',
  'staff.filter.dismissed': 'Показывать уволенных',

  'staff.col.name': 'Сотрудник',
  'staff.col.roles': 'Роли',
  'staff.col.login': 'Логин',
  'staff.col.status': 'Статус',
  'staff.col.totp': 'Второй фактор',
  'staff.col.password': 'Пароль сменён',

  'staff.status.active': 'Работает',
  'staff.status.suspended': 'Заблокирован',
  'staff.status.dismissed': 'Уволен',
  'staff.status.locked': 'Вход заблокирован до {until}',
  'staff.totp.on': 'подключён',
  'staff.totp.off': 'нет',
  'staff.mustChange': 'сменит пароль при входе',

  'staff.empty': 'Сотрудников нет',
  'staff.empty.reason':
    'На выбранном объекте нет ни одной учётной записи. Заведите первую кнопкой «Добавить».',

  'staff.add': 'Добавить сотрудника',
  'staff.form.title': 'Новый сотрудник',
  'staff.form.name': 'Имя и фамилия',
  'staff.form.phone': 'Телефон',
  'staff.form.login': 'Логин',
  'staff.form.password': 'Пароль',
  'staff.form.passwordHint':
    'Не короче 12 символов и хотя бы двух разных видов. Сотрудник сменит его при первом входе.',
  'staff.form.pin': 'PIN для планшета и кассы',
  'staff.form.pinHint': 'От 4 до 8 цифр. Можно оставить пустым и задать позже.',
  'staff.form.role': 'Роль',
  'staff.form.site': 'Объект',
  'staff.form.site.network': 'Вся сеть',
  'staff.form.submit': 'Завести',
  'staff.form.cancel': 'Отмена',
  'staff.form.required': 'Заполните имя, логин и пароль',
  'staff.form.created': 'Сотрудник заведён',

  'staff.card.profile': 'Данные',
  'staff.card.history': 'История изменений',
  'staff.card.roles': 'Роли и объекты',
  'staff.card.account': 'Учётная запись',
  'staff.card.save': 'Сохранить',
  'staff.card.saved': 'Сохранено',

  'staff.roles.add': 'Выдать роль',
  'staff.roles.revoke': 'Снять',
  'staff.roles.granted': 'Роль выдана',
  'staff.roles.revoked': 'Роль снята',
  'staff.roles.empty': 'Ролей нет — сотрудник не увидит ни одного раздела',
  'staff.roles.revokeConfirm': 'Снять роль?',
  'staff.roles.revokeEffect': 'Доступ к объекту пропадёт немедленно',

  'staff.account.password': 'Задать пароль',
  'staff.account.passwordDone': 'Пароль задан, сессии отозваны',
  'staff.account.passwordConfirm': 'Задать новый пароль?',
  'staff.account.passwordEffect1': 'Все открытые сессии сотрудника будут отозваны',
  'staff.account.passwordEffect2': 'При первом входе сотрудник обязан сменить пароль сам',
  'staff.account.pin': 'Задать PIN',
  'staff.account.pinDone': 'PIN задан',
  'staff.account.unlock': 'Снять блокировку входа',
  'staff.account.unlocked': 'Блокировка снята',
  'staff.account.sessions': 'Отозвать все сессии',
  'staff.account.sessionsDone': 'Отозвано сессий: {count}',
  'staff.account.totpReset': 'Сбросить второй фактор',
  'staff.account.totpResetConfirm': 'Сбросить второй фактор?',
  'staff.account.totpResetEffect1': 'Сотрудник не войдёт, пока не подключит фактор заново',
  'staff.account.totpResetEffect2': 'Новый секрет увидит только он сам — администратору он не показывается',
  'staff.account.totpResetDone': 'Второй фактор сброшен',
  'staff.account.none': 'Учётной записи нет — входить сотруднику нечем',

  'staff.status.change': 'Статус',
  'staff.status.suspend': 'Заблокировать',
  'staff.status.restore': 'Вернуть в работу',
  'staff.status.dismiss': 'Уволить',
  'staff.status.dismissConfirm': 'Уволить сотрудника?',
  'staff.status.dismissWord': 'УВОЛИТЬ',
  'staff.status.dismissEffect1': 'Все сессии будут отозваны, вход станет невозможен',
  'staff.status.dismissEffect2': 'Роли и записи журнала сохранятся — история не переписывается',
  'staff.status.dismissEffect3': 'Удалить сотрудника нельзя: на него ссылаются визиты, смены и журнал',
  'staff.status.changed': 'Статус изменён',

  'staff.profile.title': 'Мой профиль',
  'staff.profile.password': 'Смена пароля',
  'staff.profile.current': 'Текущий пароль',
  'staff.profile.new': 'Новый пароль',
  'staff.profile.repeat': 'Ещё раз',
  'staff.profile.mismatch': 'Пароли не совпадают',
  'staff.profile.changed': 'Пароль изменён',
  'staff.profile.mustChange':
    'Пароль задан администратором. Смените его — до этого остальные разделы недоступны.',
  'staff.profile.totp': 'Второй фактор',
  'staff.profile.totpOn': 'Подключён.',
  'staff.profile.totpOff': 'Не подключён.',
  'staff.profile.totpStart': 'Подключить аутентификатор',
  'staff.profile.totpSecret': 'Секрет показывается один раз',
  'staff.profile.totpManual':
    'Добавьте запись в приложении-аутентификаторе вручную: алгоритм SHA1, 6 цифр, 30 секунд.',
  'staff.profile.totpCode': 'Код из приложения',
  'staff.profile.totpConfirm': 'Подтвердить',
  'staff.profile.totpDone': 'Второй фактор подключён',
  'staff.profile.copy': 'Скопировать',
  'staff.profile.copied': 'Скопировано',
} as const;

const KK: Record<keyof typeof RU, string> = {
  'staff.title': 'Қызметкерлер',
  'staff.subtitle': 'Тіркелгілер, нысандар бойынша рөлдер және кіру құралдары',

  'staff.tab.list': 'Тізім',
  'staff.tab.profile': 'Менің профилім',

  'staff.filter.site': 'Нысан',
  'staff.filter.site.any': 'Барлық қолжетімді',
  'staff.filter.status': 'Мәртебе',
  'staff.filter.status.any': 'Кез келген',
  'staff.filter.dismissed': 'Жұмыстан шыққандарды көрсету',

  'staff.col.name': 'Қызметкер',
  'staff.col.roles': 'Рөлдер',
  'staff.col.login': 'Логин',
  'staff.col.status': 'Мәртебе',
  'staff.col.totp': 'Екінші фактор',
  'staff.col.password': 'Құпия сөз ауыстырылды',

  'staff.status.active': 'Жұмыс істейді',
  'staff.status.suspended': 'Бұғатталған',
  'staff.status.dismissed': 'Жұмыстан шыққан',
  'staff.status.locked': 'Кіру {until} дейін бұғатталған',
  'staff.totp.on': 'қосылған',
  'staff.totp.off': 'жоқ',
  'staff.mustChange': 'кіргенде құпия сөзді ауыстырады',

  'staff.empty': 'Қызметкерлер жоқ',
  'staff.empty.reason':
    'Таңдалған нысанда бірде-бір тіркелгі жоқ. «Қосу» түймесімен алғашқысын жасаңыз.',

  'staff.add': 'Қызметкер қосу',
  'staff.form.title': 'Жаңа қызметкер',
  'staff.form.name': 'Аты-жөні',
  'staff.form.phone': 'Телефон',
  'staff.form.login': 'Логин',
  'staff.form.password': 'Құпия сөз',
  'staff.form.passwordHint':
    '12 таңбадан кем емес және кемінде екі түрлі таңба. Қызметкер алғаш кіргенде оны ауыстырады.',
  'staff.form.pin': 'Планшет пен касса үшін PIN',
  'staff.form.pinHint': '4-тен 8-ге дейінгі сан. Бос қалдырып, кейін беруге болады.',
  'staff.form.role': 'Рөл',
  'staff.form.site': 'Нысан',
  'staff.form.site.network': 'Бүкіл желі',
  'staff.form.submit': 'Жасау',
  'staff.form.cancel': 'Болдырмау',
  'staff.form.required': 'Аты-жөнін, логинді және құпия сөзді толтырыңыз',
  'staff.form.created': 'Қызметкер жасалды',

  'staff.card.profile': 'Деректер',
  'staff.card.history': 'Өзгерістер тарихы',
  'staff.card.roles': 'Рөлдер мен нысандар',
  'staff.card.account': 'Тіркелгі',
  'staff.card.save': 'Сақтау',
  'staff.card.saved': 'Сақталды',

  'staff.roles.add': 'Рөл беру',
  'staff.roles.revoke': 'Алып тастау',
  'staff.roles.granted': 'Рөл берілді',
  'staff.roles.revoked': 'Рөл алынды',
  'staff.roles.empty': 'Рөлдер жоқ — қызметкер бірде-бір бөлімді көрмейді',
  'staff.roles.revokeConfirm': 'Рөлді алып тастау керек пе?',
  'staff.roles.revokeEffect': 'Нысанға қолжетімділік дереу жоғалады',

  'staff.account.password': 'Құпия сөз беру',
  'staff.account.passwordDone': 'Құпия сөз берілді, сессиялар тоқтатылды',
  'staff.account.passwordConfirm': 'Жаңа құпия сөз берілсін бе?',
  'staff.account.passwordEffect1': 'Қызметкердің барлық ашық сессиялары тоқтатылады',
  'staff.account.passwordEffect2': 'Алғаш кіргенде қызметкер құпия сөзді өзі ауыстыруға міндетті',
  'staff.account.pin': 'PIN беру',
  'staff.account.pinDone': 'PIN берілді',
  'staff.account.unlock': 'Кіру бұғатын алу',
  'staff.account.unlocked': 'Бұғат алынды',
  'staff.account.sessions': 'Барлық сессияны тоқтату',
  'staff.account.sessionsDone': 'Тоқтатылған сессиялар: {count}',
  'staff.account.totpReset': 'Екінші факторды тастау',
  'staff.account.totpResetConfirm': 'Екінші фактор тасталсын ба?',
  'staff.account.totpResetEffect1': 'Қызметкер факторды қайта қоспайынша кіре алмайды',
  'staff.account.totpResetEffect2': 'Жаңа құпияны тек өзі көреді — әкімшіге көрсетілмейді',
  'staff.account.totpResetDone': 'Екінші фактор тасталды',
  'staff.account.none': 'Тіркелгі жоқ — қызметкердің кіретін ештеңесі жоқ',

  'staff.status.change': 'Мәртебе',
  'staff.status.suspend': 'Бұғаттау',
  'staff.status.restore': 'Жұмысқа қайтару',
  'staff.status.dismiss': 'Жұмыстан шығару',
  'staff.status.dismissConfirm': 'Қызметкер жұмыстан шығарылсын ба?',
  'staff.status.dismissWord': 'ШЫҒАРУ',
  'staff.status.dismissEffect1': 'Барлық сессия тоқтатылады, кіру мүмкін болмайды',
  'staff.status.dismissEffect2': 'Рөлдер мен журнал жазбалары сақталады — тарих қайта жазылмайды',
  'staff.status.dismissEffect3':
    'Қызметкерді жоюға болмайды: оған келулер, ауысымдар және журнал сілтейді',
  'staff.status.changed': 'Мәртебе өзгертілді',

  'staff.profile.title': 'Менің профилім',
  'staff.profile.password': 'Құпия сөзді ауыстыру',
  'staff.profile.current': 'Ағымдағы құпия сөз',
  'staff.profile.new': 'Жаңа құпия сөз',
  'staff.profile.repeat': 'Тағы бір рет',
  'staff.profile.mismatch': 'Құпия сөздер сәйкес келмейді',
  'staff.profile.changed': 'Құпия сөз өзгертілді',
  'staff.profile.mustChange':
    'Құпия сөзді әкімші берген. Оны ауыстырыңыз — оған дейін басқа бөлімдер қолжетімсіз.',
  'staff.profile.totp': 'Екінші фактор',
  'staff.profile.totpOn': 'Қосылған.',
  'staff.profile.totpOff': 'Қосылмаған.',
  'staff.profile.totpStart': 'Аутентификаторды қосу',
  'staff.profile.totpSecret': 'Құпия бір рет қана көрсетіледі',
  'staff.profile.totpManual':
    'Аутентификатор қосымшасына жазбаны қолмен қосыңыз: алгоритм SHA1, 6 сан, 30 секунд.',
  'staff.profile.totpCode': 'Қосымшадағы код',
  'staff.profile.totpConfirm': 'Растау',
  'staff.profile.totpDone': 'Екінші фактор қосылды',
  'staff.profile.copy': 'Көшіру',
  'staff.profile.copied': 'Көшірілді',
};

export type StaffKey = keyof typeof RU;
export type StaffLocale = 'ru' | 'kk';

const DICTS: Readonly<Record<StaffLocale, Record<StaffKey, string>>> = { ru: RU, kk: KK };

export type StaffTranslate = (
  key: StaffKey,
  params?: Record<string, string | number>,
) => string;

export function makeStaffT(locale: StaffLocale): StaffTranslate {
  const dict = DICTS[locale] ?? RU;
  return (key, params) => {
    const template = dict[key] ?? RU[key] ?? key;
    if (!params) return template;
    return template.replace(/\{(\w+)\}/g, (match, name: string) =>
      params[name] === undefined ? match : String(params[name]),
    );
  };
}
